import { Length, IsOptional, IsEmail, IsNumberString, MinLength } from 'class-validator';

export class UsuarioValidate {
    @Length(1, 100)
    Nombre: string;
    @IsNumberString()
    @MinLength(9)
    Telefono1: string;
    @IsOptional()
    @IsNumberString()
    @MinLength(9)
    Telefono2: string;
    @IsEmail()
    EMail: string;
}